import { combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { AlertReducerFunction } from './reducers/alert-reducer';
import { BaseViewReducerFunction } from './reducers/base-view-reducer';
import { BottleReturnReducerFunction } from './reducers/bottle-return-response-reducer';
import { CashDrawerReducerFunction } from './reducers/cash-drawer-reducer';
import { CashOfficeReducerFunction } from './reducers/cash-office-reducer';
import { CashierPreferencesReducerFunction } from './reducers/cashier-preferences-reducer';
import { CommandMenuReducerFunction } from './reducers/command-menu-reducer';
import { CustomerDisplayReducerFunction } from './reducers/customer-display-reducer';
import { DeviceNotificationFunction } from './reducers/device-notification-reducer';
import { DeviceStatusReducerFunction } from './reducers/device-status-reducer';
import { EndOfDayReducerFunction } from './reducers/end-of-day-reducer';
import { InterventionsReducerFunction } from './reducers/interventions-reducer';
import { ItemListReducerFunction } from './reducers/item-list-reducer';
import { LoginReducerFunction } from './reducers/login-reducer';
import { MenuPanelReducerFunction } from './reducers/menu-panel-reducer';
import { MergeTransactionReducerFunction } from './reducers/merge-transaction-reducer';
import { MICRReducerFunction } from './reducers/micr-reducer';
import { MiddleAreaReducerFunction } from './reducers/middle-area-reducer';
import { NotificationReducerFunction } from './reducers/notification-reducer';
import { PinPadReducerFunction } from './reducers/pinpad-reducer';
import { PluMenuReducerFunction } from './reducers/plu-menu-reducer';
import { POSModeReducerFunction } from './reducers/pos-mode-reducer';
import { PosUiMenuReducerFunction } from './reducers/pos-ui-menu-reducer';
import { PriceCheckReducerFunction } from './reducers/price-check-response-reducer';
import { RecallOrderReducerFunction } from './reducers/recall-order-reducer';
import { ResetPasswordFunction } from './reducers/reset-password-reducer';
import { SalesKeypadReducerFunction } from './reducers/sales-keypad-reducer';
import { ScaleReducerFunction } from './reducers/scale-reducer';
import { SidebarReducerFunction } from './reducers/sidebar-reducer';
import { TabMenuReducerFunction } from './reducers/tab-menu-reducer';
import { TareWeightGroupsReducerFunction } from './reducers/tare-weight-groups-reducer';
import { TbrReducerFunction } from './reducers/tbr-reducer';
import { TenderMenuReducerFunction } from './reducers/tender-menu-reducer';
import { TenderingReducerFunction } from './reducers/tendering-reducer';
import { TouchpointReducerFunction } from './reducers/touchpoint-reducer';
import { TransactionReducerFunction } from './reducers/transaction-reducer';
import { TransactionSearchReducerFunction } from './reducers/transaction-search-reducer';
import { BRMInputReducerFunction } from './reducers/brm-input-reducer';
import { BalanceInquiryReducerFunction } from './reducers/balance-inquiry-reducer';
import { TenderExchangeReducerFunction } from './reducers/tender-exchange-reducer';
import { TareWeightPercentagesReducerFunction } from './reducers/tare-weight-percentages-reducer';

const rootReducer = combineReducers({
  alert: AlertReducerFunction,
  salesKeypad: SalesKeypadReducerFunction,
  user: LoginReducerFunction,
  itemList: ItemListReducerFunction,
  sidebar: SidebarReducerFunction,
  tendering: TenderingReducerFunction,
  pluMenu: PluMenuReducerFunction,
  tenderMenu: TenderMenuReducerFunction,
  notification: NotificationReducerFunction,
  deviceStatus: DeviceStatusReducerFunction,
  menuPanel: MenuPanelReducerFunction,
  touchPoint: TouchpointReducerFunction,
  recallOrder: RecallOrderReducerFunction,
  commandMenu: CommandMenuReducerFunction,
  posUiMenu: PosUiMenuReducerFunction,
  transaction: TransactionReducerFunction,
  mergeTransaction: MergeTransactionReducerFunction,
  middleArea: MiddleAreaReducerFunction,
  interventions: InterventionsReducerFunction,
  cashOffice: CashOfficeReducerFunction,
  cashDrawer: CashDrawerReducerFunction,
  pinPad: PinPadReducerFunction,
  endOfDayActivity: EndOfDayReducerFunction,
  tareWeightGroups: TareWeightGroupsReducerFunction,
  posMode: POSModeReducerFunction,
  cashierPreferences: CashierPreferencesReducerFunction,
  baseView: BaseViewReducerFunction,
  scale: ScaleReducerFunction,
  customerDisplayScreen: CustomerDisplayReducerFunction,
  resetPassword: ResetPasswordFunction,
  micr: MICRReducerFunction,
  priceCheck: PriceCheckReducerFunction,
  tabMenu: TabMenuReducerFunction,
  bottleReturn: BottleReturnReducerFunction,
  transactionSearch: TransactionSearchReducerFunction,
  tbr: TbrReducerFunction,
  brmInput: BRMInputReducerFunction,
  balanceInquiry: BalanceInquiryReducerFunction,
  tenderExchange: TenderExchangeReducerFunction,
  deviceNotification: DeviceNotificationFunction,
  tareWeightPercentages: TareWeightPercentagesReducerFunction,
});

export type AppState = ReturnType<typeof rootReducer>;

const composeEnhancers = composeWithDevTools({
  name: 'Emerald XLR',
  maxAge: 10,
});

export const store = createStore(rootReducer, composeEnhancers());
